/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_Page_TitleInputs */

const fr_plan_choice_page_title = /** @type {(inputs: Plan_Choice_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir ma formule`)
};

/**

* @param {Plan_Choice_Page_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_page_title = /** @type {((inputs?: Plan_Choice_Page_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_Page_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_page_title(inputs)
});